'use client';

export interface HubNewsSearchPillUnitProps {
    label: string;
    count: number;
    isSelected: boolean;
    onClick: () => void;
}

export default function HubNewsSearchPillUnit({ label, count, isSelected, onClick }: HubNewsSearchPillUnitProps) {
    const isDisabled = count === 0 && !isSelected;
    const baseClass =
        'inline-flex items-center gap-2 h-8 px-3 rounded-lg border whitespace-nowrap font-corp font-medium text-[13px] transition-colors duration-150 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed';
    const stateClass = isSelected
        ? 'bg-color-base text-color-white-base border-gray-700'
        : 'bg-color-base-2 bg-opacity-10 text-color-base-2 border-color-base-2 border-opacity-30';
    const hoverClass = isSelected || isDisabled ? '' : 'hover:bg-opacity-20 hover:border-opacity-60';
    const countClass = isSelected ? 'text-color-white-base/70' : 'text-color-base-2/70';

    return (
        <button
            type="button"
            disabled={isDisabled}
            className={`${baseClass} ${stateClass} ${hoverClass}`}
            onClick={onClick}
            aria-pressed={isSelected}
        >
            {label}
            <span className={`font-cantarell font-bold text-[11px] tabular-nums ${countClass}`}>{count}</span>
        </button>
    );
}
